import React, { useState } from "react";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { AmenitiesMasterHeader,} from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import RoomMasterPopup from "../popup-containers/RoomMasterPopup";
import InputText from "../ReusableComponents/InputText";
import { BindPostAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import { useEffect } from "react";
import { BindAPI } from "../services/APIConnection";
import Loader from "../ReusableComponents/Loader";
import { Key } from "lucide-react";
import AmenitiesPopup from "../popup-containers/Amenitiespopup";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const Amenities = () => {
  // UI state management
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [roomTypeDD, setRoomTypeDD] = useState([]);
  // Grid data
  const [bindAmenities, setBindAmenities] = useState([]);
  // Form data and error handling
  const [popUpData, setPopUpData] = useState({});
  var createdBy = sessionStorage.getItem("createdBy");
  const [MstAmenitiesId, setMstAmenitiesId] = useState("");
   var mstClientId = sessionStorage.getItem("MstClientId");

  // Used to store values
  const [formFields, setFormFields] = useState({
    amenities: "",
    description: "",
  });

  //Show error message
  const [formFieldsError, setFormFieldsError] = useState({
    amenitiesError: "",
    descriptionError: "",
  });

  // Load data on mount
  useEffect(() => {
    // bind gird datas
    BindAmenities();
  }, []);

  // Fetch grid data from API
  const BindAmenities = async () => {
    const data={
      mstClientId:mstClientId
    }
    setIsLoading(true); 
    const response = await BindPostAPI( data,"AmenitiesAPI/BindAmenities");

    if (response && response.data ) {
      setBindAmenities(response.data.Table);
      setIsLoading(false); 
      
    } 
  };

    const fieldLabels = {
    amenities: { label: 'Amenities', type: 'text' },
    description:{ label: 'Description', type: 'text' },
    // Add more fields here as needed
  };

   const handleBlur = (e) => {
    const { name, value } = e.target;
    const field = fieldLabels[name];
    if (!field) return;

    const label = field.label;
    const type = field.type;

    const message = value.trim() === ''
      ? (type === 'select-one' ? `Select ${label}` : `Enter ${label}`)
      : '';

    setFormFieldsError((prevErrors) => ({
      ...prevErrors,
      [`${name}Error`]: message
    }));
  };

  // Validation Error
   const validateForm = () => {
  const errors = {};

  if (!formFields.amenities?.trim()) {
    errors.amenitiesError = "Enter Amenities";
  }

  if (!formFields.description) {
    errors.descriptionError = "Enter Description";
  }

  setFormFieldsError(errors);

  // Return true if there are no errors
  return Object.keys(errors).length === 0;
};

  // Show add form
  const showAdd = () => {
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setVisibleAdd(true);
  };

  //This is overall cancel button
  const cancel = () => {
    BindAmenities();
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setVisibleAdd(false);
    setIsLoading(false);
    setSubmitBtnDisabled(false);
    setMstAmenitiesId("");
    setFormFields({
      amenities: "",
      description: "",
    });
    setFormFieldsError({
      amenitiesError: "",
      descriptionError: "",
    });
    setpopUpOpen(false);
  };

  // Open popup
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  //This function is helped to the view, delete, block and unblock input value via rowindex passing
  const handleAmenities = (rowIndex, flag) => {
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }

    const rowData = bindAmenities[rowIndex];
    setMstAmenitiesId(bindAmenities[rowIndex].MstAmenitiesId);

    setPopUpData(rowData);
  };


  console.log("formFieldsError:", formFieldsError);

  // Handle edit button click
  const handleEdit = (rowIndex) => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstAmenitiesId(bindAmenities[rowIndex].MstAmenitiesId);
    setFormFields({
      ...formFields,
      amenities: bindAmenities[rowIndex].Amenities,
      description: bindAmenities[rowIndex].Description,
    });
  };

  // const handleBlur = () => {
    
  //   const updatedErrors = {
  //     ...formFieldsError,
  //     roomNameError: formFields.roomName ? "" : "Enter Room Name",
  //     roomTypeError: formFields.mstRoomTypeId ? "" : "Select Room Type",
  //   };

  //   const isFormValid = Object.values(updatedErrors).every(
  //     (error) => error === ""
  //   );

  //   if (isFormValid) {
  //     const mstRoomTypeId = parseInt(formFields.mstRoomTypeId);
  //     const roomName = formFields.roomName?.trim();

  //     // const isDuplicate = bindRoomMasterDatas.some(
  //     //   (data) =>
  //     //     data.MstRoomTypeId === mstRoomTypeId && data.RoomName === roomName
  //     // );

  //     // if (isDuplicate) {
  //     //   updatedErrors.roomNameError =
  //     //     "This room name is already available for this room type.";
  //     // } else {
  //     //   updatedErrors.roomNameError = "";
  //     //   updatedErrors.roomTypeError = "";
  //     // }
  //   }

  //   setFormFieldsError(updatedErrors);

  //   // Final validation check after duplicate check
  //   const isFormValidCheck = Object.values(updatedErrors).every(
  //     (error) => error === ""
  //   );

  //   return isFormValidCheck;
  // };

  // const handleFieldsChange = (value, name) => {
  //   setFormFields({
  //     ...formFields,
  //     [name]: value,
  //   });
  // };

  // let isFormValidCheck;

  // Submit form for add/update/delete/Active/In Active
  const handleSubmit = async (rowIndex, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const isValid = validateForm();

    if (flag == 1 || flag == 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        return;
      }
      if (isValid) {
        setIsOpen(false);
        setIsLoading(true);
        const data = {
          MstAmenitiesId: MstAmenitiesId || 0,
            mstClientId :  mstClientId ,
          Amenities: formFields.amenities,
          Description: formFields.description,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "AmenitiesAPI/IUDAmenities");
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Amenities data inserted successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Amenities data insert failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Amenities data modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Amenities data modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
        MstAmenitiesId: MstAmenitiesId ? MstAmenitiesId : 0,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "AmenitiesAPI/IUDAmenities");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Amenities data deleted successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to delete amenities data. 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Amenities data Inactivated successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Amenities data Inactivated failed 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Amenities data activated successfully! 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Amenities data activated failed! 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
    }
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Amenities"
          header={AmenitiesMasterHeader}
          records={bindAmenities}
          handleAction={handleAmenities}
          handleEdit={handleEdit}
          blockView={true}
          showAdd={showAdd}
        />
      )}
      {visibleAdd && (
        <div>
          <AddScreenTitle
            title="Amenities"
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
          />

          <div class="mx-auto  md:w-[500px] w-full">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <InputText
                      inputType="text"
                      title="Amenities"
                      name="amenities"
                      classStar="text-red-500"
                      content={formFields.amenities}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          amenities: e.target.value,
                        })
                      }
                      controlFuncBlur={handleBlur}
                      errorMessage={formFieldsError.amenitiesError}
                    />

                    <TextArea
                      title="Description"
                      rows={7}
                      name="description"
                      placeholder="Enter Description"
                      classStar="text-red-500"
                      maxLength={500}
                      content={formFields.description}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          description: e.target.value,
                        })
                      }
                      errorMessage={formFieldsError.descriptionError}

                      controlFuncBlur={handleBlur}
                    />
                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                      disabledBtn={submitBtnDisabled ? true : false}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
        {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleAmenities}
      >
        <div>
          <PopUpScreenTitle
            title="Amenities"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <AmenitiesPopup data={popUpData} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          disabledBtn={submitBtnDisabled ? true : false}
          handleSubmit={handleSubmit}
          cancel={cancel}
        />
      </MainPopup>
    </MainLayout>
  );
};
export default Amenities;
